import { render, staticRenderFns } from "./ServiceOrdersManage.vue?vue&type=template&id=6fca9a57&scoped=true"
import script from "./ServiceOrdersManage.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersManage.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrdersManage.vue?vue&type=style&index=0&id=6fca9a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca9a57",
  null
  
)

export default component.exports